import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-display-text',
    templateUrl: './his-display-text.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayTextComponent implements OnInit {
    @Input() text = '';
    @Input() params: any[] = [];
    @Input() format = 'text'; // Formats: 'text' | 'html' | 'html-unsafe'

    ngOnInit() {
        // Convert text parameters to HTML (except for format 'html-unsafe')
        if ( this.params && this.params.length > 0 && this.format !== 'html-unsafe' ) {
            let params = [];
            for ( let param of this.params ) {
                params.push( this.toHTML( param || '' ) );
            }
            this.params = params;
        }
    }

    private toHTML( s: string ) {
        const entityMap: any = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '&': '&amp;',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '<': '&lt;',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '>': '&gt;',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '"': '&quot;',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '\'': '&#39;',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '/': '&#x2F;',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '`': '&#x60;',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '=': '&#x3D;'
        };

        return String( s ).replace( /[&<>"'`=\/]/g, ( t ) => {
            return entityMap[t];
        } );
    }
}
